<template>
    <div class="card col-12 no-padding" style="margin-left: -5px">
        <span
            style="margin-top: 10px; margin-bottom: 10px"
            @click="showCodePanel = !showCodePanel"
        >
            <i
                style="color: red"
                class="fa fa-plus fa-3"
                :class="{
                    'fa-plus': !showCodePanel,
                    'fa-minus': showCodePanel,
                }"
                aria-hidden="true"
            ></i
            >&nbsp; Add discount code</span
        >

        <div v-if="showCodePanel" class="card-body">
            <form
                name="discountCodeForm"
                class="form-inline"
                @submit.prevent="submitCode()"
                novalidate
            >
                <div class="form-group">
                    <div class="input-group mb-3">
                        <input
                            type="text"
                            v-validate="'required'"
                            v-model="discountCode"
                            data-vv-as="discount code"
                            placeholder="Enter Code"
                            class="form-control"
                            id="codeField"
                            name="codeInput"
                        />
                        <div class="input-group-append">
                            <button
                                type="submit"
                                :style="{
                                    'background-color': event.buttoncolour,
                                    'border-color': event.buttoncolour,
                                }"
                                style="margin-top: 0px"
                                class="btn btn-primary"
                            >
                                Apply
                            </button>
                        </div>
                    </div>
                    <div v-show="!valid && submitted" class="text-danger">
                        Please add a valid code
                    </div>
                </div>
                <div class="col-12" style="margin-left -5px;">
                    <h6 v-if="code && !code.ticket_id">
                        Discount of: {{ code.value }}% will be applied
                    </h6>
                    <h6 v-if="ticketCodes && ticketCodes.length > 0">
                        Discount applied to ticket, see above for details
                    </h6>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import PaymentBus from './payment-bus';

export default {
    data() {
        return {
            tickets: this.$store.getters.getSelectedTickets,
            event: this.$store.getters.getEvent,
            bookerDetails: this.$store.getters.getBookerDetails,
            valid: false,
            submitted: false,
            discountCode: '',
            code: null,
            showCodePanel: false,
            ticketCodes: [],
        };
    },

    methods: {
        submitCode() {
            var self = this;
            this.submitted = true;

            this.$validator
                .validateAll()
                .then((result) => {
                    if (!result) {
                        self.$notify.error({
                            title: 'Invalid Code',
                            message: 'Please add a valid code!',
                        });
                        self.valid = false;
                        self.submitted = false;
                        return;
                    }

                    self.$parent.showStripeForm = false;

                    self.valid = true;
                    this.$http
                        .put('/discounts/' + this.event.id + '/check_valid', {
                            code: self.discountCode,
                            packages: self.tickets,
                            ticketCodes: self.ticketCodes,
                            bookerEmail: self.bookerDetails.email,
                        })
                        .then(
                            function (response) {
                                var code = response.data.code;

                                if (code.ticket_id) {
                                    // TODO add this to VUEX, whole object, now just the code
                                    self.ticketCodes.push(code.id);
                                    if (!self.addDiscountToTicket(code)) {
                                        self.$notify.error({
                                            title: 'Invalid Code',
                                            message:
                                                'Code not valid for selected tickets!',
                                        });
                                        return;
                                    }
                                    self.$parent.fees = response.data.fees;
                                    self.$store.commit(
                                        'setFees',
                                        response.data.fees
                                    );
                                    self.$store.commit(
                                        'setBookingToken',
                                        response.data.booking_token
                                    );
                                    self.$parent.calcCosts();

                                    if (self.$parent.costNet == 0) {
                                        self.setFreeBooking();
                                        //self.$parent.completeBooking(null, null, null, true);
                                    } else {
                                        if (
                                            self.$parent.paymentMethod == 'Card'
                                        ) {
                                            PaymentBus.$emit(
                                                '   ',
                                                true,
                                                'card',
                                                false
                                            );
                                        }
                                        self.$notify.success({
                                            title: 'Success',
                                            message:
                                                'Code applied successfully!',
                                        });
                                    }
                                } else {
                                    self.code = code;
                                    self.$parent.fees = response.data.fees;
                                    self.$store.commit(
                                        'setFees',
                                        response.data.fees
                                    );
                                    self.$store.commit(
                                        'setBookingToken',
                                        response.data.booking_token
                                    );

                                    self.$parent.discountCodeId = self.code.id;

                                    if (self.$parent.fees.free_booking) {
                                        self.setFreeBooking();
                                        //self.$parent.completeBooking(null, null, null, true);
                                    } else {
                                        self.$parent.discountAmount =
                                            self.code.value;
                                        self.$parent.calcCosts();
                                        if (
                                            self.$parent.paymentMethod == 'Card'
                                        ) {
                                            PaymentBus.$emit(
                                                'getBookingIntent',
                                                true,
                                                'card',
                                                false
                                            );
                                        }
                                        self.$notify.success({
                                            title: 'Success',
                                            message:
                                                'Code applied successfully!',
                                        });
                                    }
                                }
                                self.discountCode = '';
                            },
                            function (response) {
                                var response = response.response;
                                if (response.data && response.data.errors) {
                                    response.data.errors.forEach(function (
                                        errorMsg
                                    ) {
                                        self.$notify({
                                            title: 'Error Saving Discounts',
                                            message: errorMsg,
                                            type: 'error',
                                        });
                                    });
                                } else {
                                    self.$notify.error({
                                        title: 'Error',
                                        message: 'Code could not be applied!',
                                    });
                                }
                            }
                        )
                        .finally(() => {
                            self.$parent.showStripeForm = true;
                        });
                })
                .catch((error) => {
                    self.$notify.error({
                        title: 'Code Error',
                        message: 'Error Validating Code',
                    });
                    self.submitted = false;
                });
        },

        setFreeBooking() {
            this.$swal({
                title: 'Success!',
                text: 'You no longer need to pay for this event!',
                confirmButtonColor: '#ff9500',
                allowOutsideClick: false,
            });
            this.$parent.discountAmount = '100';
        },

        addDiscountToTicket(code) {
            var ticket = this.tickets.find(
                (ticket) => ticket.id === code.ticket_id
            );
            if (ticket) {
                ticket.discount_code_id = code.id;
                ticket.discount_type = code.discount_type;
                ticket.discount_amount = code.value;
                this.$parent.$forceUpdate();
                return true;
            } else {
                return false;
            }
        },
    },
};
</script>
